import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { giveFeedback } from './appFeedbackActionCreators';

const FeedbackFormContent = ({ content, handleContentChange, charactersLeft }) => (
    <>
        <p>Note: this feedback will be only sent to the Egnyte support team</p>
        <textarea
            rows="6"
            className="ast-app-feedback__text"
            placeholder="Why do you like or dislike this integration?"
            maxLength="2000"
            value={content}
            onChange={handleContentChange}
        />
        <p className="sg-txt-tiny ast-app-feedback__counter">Characters left: {charactersLeft}</p>
    </>
);

FeedbackFormContent.propTypes = {
    content: PropTypes.string,
    handleContentChange: PropTypes.func.isRequired,
    charactersLeft: PropTypes.number.isRequired,
};

const feedbackFormHOC = connect(
    (state) => ({
        ...state.appFeedback,
        user: state.user.exists,
        appLogo: state.appDetails.app ? state.appDetails.app.appLogo : null,
    }),
    {
        dispatchFeedback: giveFeedback,
    }
);

function useFeedbackHandlers(appId, dispatchFeedback) {
    const [content, setContent] = useState('');
    const [charactersLeft, setCharactersLeft] = useState(2000);

    const handleContentChange = (e) => {
        setContent(e.target.value);
        setCharactersLeft(e.target.maxLength - e.target.value.length);
    };
    const sendFeedback = () => {
        dispatchFeedback(appId, content);
        setContent('');
        setCharactersLeft(2000);
    };

    return { content, charactersLeft, handleContentChange, sendFeedback };
}

export { feedbackFormHOC, useFeedbackHandlers, FeedbackFormContent };
